import Layout from '@/components/layout/Layout';

const Disclaimer = () => {
  return (
    <Layout>
      <section className="relative pt-8 pb-12 bg-background overflow-hidden min-h-screen">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px] z-0" />

        <div className="container-max max-w-4xl relative z-10 px-4">
          <span className="inline-block px-4 py-2 bg-accent/5 border border-accent/20 rounded-full text-accent-foreground text-[10px] font-black uppercase tracking-[0.2em] mb-8">
            Legal Framework
          </span>
          <h1 className="text-2xl md:text-4xl font-black text-primary mb-12 tracking-tighter uppercase">Institutional <br /><span className="text-gradient-gold">Disclaimer</span></h1>

          <div className="card-premium !p-12 bg-white/40 border-white/60 backdrop-blur-xl">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tighter prose-p:text-muted-foreground prose-p:font-medium prose-p:leading-relaxed">
              <p className="text-sm font-black text-accent uppercase tracking-widest mb-12 pb-8 border-b border-gray-100">
                Effective Revision: January 2024
              </p>

              <h2 className="text-2xl mb-6">Risk Disclosure</h2>
              <p>
                Trading in the stock market involves substantial risk and is not suitable for every investor. The valuation of stocks and other securities may fluctuate, and, as a result, clients may lose more than their original investment.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Educational Purpose Only</h2>
              <p>
                The content provided by Ratchagan Analysis, including but not limited to courses, videos, articles, and community discussions, is for educational and informational purposes only. It should not be considered as financial, investment, or trading advice.
              </p>

              <h2 className="text-2xl mt-12 mb-6">No Guarantee of Results</h2>
              <p>
                Past performance is not indicative of future results. The results shown in our educational materials are based on historical data and do not guarantee future success. Each individual's trading results may vary based on their own skills, knowledge, and market conditions.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Consult a Professional</h2>
              <p>
                Before making any investment decisions, we strongly recommend consulting with a qualified financial advisor or investment professional who can assess your individual circumstances and provide personalized advice.
              </p>

              <h2 className="text-2xl mt-12 mb-6">No Responsibility for Losses</h2>
              <p>
                Ratchagan Analysis and its team members shall not be liable for any losses or damages arising from the use of our educational content or any investment decisions made based on our materials.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Market Risks</h2>
              <p>
                Stock market trading involves various risks including but not limited to market risk, liquidity risk, and currency risk. Traders should be prepared to accept the risk of losing their entire investment.
              </p>

              <div className="mt-16 pt-12 border-t border-gray-100 italic">
                <p className="text-sm">
                  Inquiries regarding this legal framework should be directed to the compliance desk at{' '}
                  <a href="mailto:ratchagananalysis@gmail.com" className="text-accent font-bold hover:underline">
                    ratchagananalysis@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Disclaimer;
